<template>
  <router-view/>
</template>

<script>
import { scrollTop, updateScrollTop } from "@/shared/utils/scrollTop"

export default {
  setup() {
    return {
      scrollTop,
      updateScrollTop,
    }
  },
  mounted() {
    document.querySelector('#app').addEventListener('scroll', this.updateScrollTop)
  },
  beforeUnmount() {
    document.querySelector('#app').removeEventListener('scroll', this.updateScrollTop)
  }
}

</script>

<style lang="scss">

#app {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
}

</style>
